export default __webpack_public_path__ + "static/media/pix.9f615d81.svg";